import getBaseViewFields from './getBaseViewFields';

// Builds the {field, aggFunc} list for the totals-row aggregation query, dropping
// any field whose saved aggFunc is no longer valid for its current type. A board's
// base view persists each field's aggFunc from creation time, so a field whose type
// later changed (e.g. a `hired` flag once defined as text/numeric still carrying a
// 'count' or 'sum' aggFunc after becoming a boolean) can carry an aggFunc the backend
// rejects — which errors the whole totals query and makes the entire totals row
// disappear, not just that column.
//
// Base-view fields can come from different datasets (each field carries its own
// `dataset`), so we resolve the dataset definition per field rather than assuming the
// board's primary dataset. Conservative: only drop a field when we can prove the
// aggFunc is invalid (the field's dataset definition is loaded, the field exists in
// it, AND its aggFunc is not in that field's aggFuncs). If the definition is missing,
// or the field isn't in it (e.g. derived/joined/dotted fields), keep it so existing
// totals aren't over-dropped.
const getValidAggregateFields = ({
  baseView,
  getDatasetDefinition,
}: {
  baseView: FleetOps.BaseView;
  getDatasetDefinition: (
    dataset: string,
  ) => FleetOps.DatasetDefinition | undefined;
}): GridAggregateField[] => {
  return getBaseViewFields(baseView)
    .filter((c) => c.aggFunc)
    .filter((c) => {
      const datasetDefinition = getDatasetDefinition(c.dataset);
      if (!datasetDefinition) {
        return true;
      }
      const defField = datasetDefinition.fields.find(
        (f) => f.field === c.field,
      );
      if (!defField) {
        return true;
      }
      return defField.aggFuncs.includes(c.aggFunc!);
    })
    .map((c) => ({
      field: c.field,
      aggFunc: c.aggFunc,
    })) as GridAggregateField[];
};

export default getValidAggregateFields;
